// Client HTTP pour /api/auth — encapsule fetch + parsing d'erreurs domaine.
const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const authApi = {
  login:    (email, password)                       => request('/auth/login',    { method: 'POST', body: { email, password } }),
  register: ({ prenom, nom, email, password })      => request('/auth/register', { method: 'POST', body: { prenom, nom, email, password } }),
  me:       (token)                                 => request('/auth/me',       { token }),
  updateMe: (token, patch)                          => request('/auth/me',       { method: 'PATCH', token, body: patch }),
  logout:   (token)                                 => request('/auth/logout',   { method: 'POST', token }),
};
